import { Injectable, inject, computed } from '@angular/core';
import { I18nStore } from '../stores/i18n.store';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  private i18nStore = inject(I18nStore);

  // ==================== Expose Store Signals ====================
  readonly language = this.i18nStore.language;
  readonly measurementSystem = this.i18nStore.measurementSystem;
  readonly languageFetched = this.i18nStore.languageFetched;

  // ==================== Computed Signals (Backward Compatibility) ====================

  readonly Lng = this.i18nStore.lng;
  readonly languageSignal = computed(() => this.i18nStore.language());
  readonly measurementSystemSignal = computed(() => this.i18nStore.measurementSystem());
  readonly measureMentSystem = this.i18nStore.pipeCompatibleMeasurementSystem;
  readonly currentMeasurementSystem = this.i18nStore.currentMeasurementSystem;
  readonly pipeCompatibleMeasurementSystem = this.i18nStore.pipeCompatibleMeasurementSystem;

  // ==================== Translation Methods ====================

  langString(key: string): string {
    return this.i18nStore.translate(key);
  }

  String(key: string): string {
    return this.i18nStore.translate(key);
  }

  string(key: string): string {
    return this.i18nStore.translate(key);
  }

  // ==================== Content Parsing ====================

  parse(source: any): string {
    return this.i18nStore.parse(source);
  }
  Parse(source: any): string {
    return this.i18nStore.parse(source);
  }

  // ==================== State Management ====================

  setLanguage(lang: string): void {
    this.i18nStore.setLanguage(lang);
  }

  setMeasurementSystem(system: string): void {
    this.i18nStore.setMeasurementSystem(system);
  }

  setLanguageFetched(lang: string): void {
    this.i18nStore.setLanguageFetched(lang);
  }

  /**
   * Clear all i18n state and reset to defaults
   */
  clear(): void {
    this.i18nStore.clear();
  }
}
